import type { Bundle } from '../types'

/** En-têtes d'écran et contenus de la vue d'ensemble. */
export const screens = {
  'screen.overview.title': { fr: "Vue d'ensemble", en: 'Overview' },
  'screen.overview.desc': {
    fr: 'État de la surveillance des marchands et des détections à traiter.',
    en: 'State of merchant monitoring and of the detections awaiting triage.',
  },
  'screen.merchants.title': { fr: 'Marchands', en: 'Merchants' },
  'screen.merchants.desc': {
    fr: 'Portefeuille des marchands surveillés, marques autorisées et fréquence de passage du robot.',
    en: 'Portfolio of monitored merchants, authorised brands and crawl frequency.',
  },
  'screen.reports.title': { fr: 'Rapports de crawl', en: 'Crawl reports' },
  'screen.reports.desc': {
    fr: "Résultat de chaque passage du robot sur les sites des marchands : niveau de risque, raisons et action recommandée.",
    en: 'Outcome of every crawl of a merchant website: risk level, reasons and recommended action.',
  },
  'screen.reportDetail.title': { fr: 'Rapport de crawl', en: 'Crawl report' },
  'screen.discovery.title': { fr: 'Usurpation de marques', en: 'Brand impersonation' },
  'screen.discovery.desc': {
    fr: 'Domaines, applications et comptes qui imitent une marque surveillée.',
    en: 'Domains, apps and accounts impersonating a monitored brand.',
  },
  'screen.webscan.title': { fr: 'Marchands non déclarés', en: 'Undeclared merchants' },
  'screen.webscan.desc': {
    fr: "Sites qui proposent un moyen de paiement surveillé sans être autorisés pour cette marque.",
    en: 'Websites offering a monitored payment method without being authorised for that brand.',
  },
  'screen.ads.title': { fr: 'Détection pubs', en: 'Ad detection' },
  'screen.betting.title': { fr: 'Paris & jeux', en: 'Betting & gambling' },
  'screen.brands.title': { fr: 'Modèles de recherche', en: 'Search templates' },
  'screen.brands.desc': {
    fr: 'Marques surveillées, termes recherchés, domaines officiels et formulations par pays.',
    en: 'Monitored brands, search terms, official domains and country-specific phrasings.',
  },
  'screen.rules.title': { fr: 'Règles pays', en: 'Country rules' },
  'screen.rules.desc': {
    fr: 'Activités autorisées, encadrées ou interdites dans chaque pays, avec leurs références légales.',
    en: 'Activities allowed, restricted or prohibited in each country, with their legal references.',
  },
  'screen.users.title': { fr: 'Utilisateurs', en: 'Users' },
  'screen.users.desc': {
    fr: "Comptes de l'organisation, rôles, pays et écrans accessibles.",
    en: 'Organisation accounts, roles, countries and accessible screens.',
  },
  'screen.orgs.title': { fr: 'Organisations', en: 'Organisations' },
  'screen.orgs.desc': {
    fr: 'Clients de la plateforme, pays couverts et abonnements.',
    en: 'Platform customers, countries covered and subscriptions.',
  },
  'screen.guide.title': { fr: 'Guide utilisateur', en: 'User guide' },

  // Bande de triage de la vue d'ensemble
  'stats.clear': {
    fr: 'Rien à traiter. Toutes les détections ont été qualifiées.',
    en: 'Nothing to triage. Every detection has been qualified.',
  },
  'stats.openAlerts': { fr: 'alertes ouvertes', en: 'open alerts' },
  'stats.suspendedMerchants': { fr: 'marchands suspendus', en: 'suspended merchants' },
  'stats.discoveryToQualify': { fr: 'usurpations à qualifier', en: 'impersonations to qualify' },
  'stats.webscanToQualify': {
    fr: 'marchands non déclarés à qualifier',
    en: 'undeclared merchants to qualify',
  },
  // Phrase coupée en deux : le nombre est mis en gras entre les deux moitiés.
  // Une balise dans le catalogue serait affichée telle quelle.
  'stats.overduePrefix': { fr: 'dont', en: 'including' },
  'stats.overdueSuffix': {
    fr: 'ouvertes depuis plus de {days} jours',
    en: 'open for more than {days} days',
  },
  'stats.monitoredMerchants': { fr: 'Marchands surveillés', en: 'Monitored merchants' },
  'stats.newThisMonth': { fr: '+{n} ce mois', en: '+{n} this month' },
  'stats.crawls24h': { fr: 'Crawls sur 24 h', en: 'Crawls over 24 h' },
  'stats.successRate': { fr: 'Taux de succès : {rate} %', en: 'Success rate: {rate}%' },
  'stats.handledDetections': { fr: 'Détections traitées', en: 'Detections handled' },
  'stats.outOfTotal': { fr: 'Sur {n} au total', en: 'Out of {n} in total' },

  // Graphiques
  'chart.alertsByLevel': { fr: 'Alertes par niveau — {days} jours', en: 'Alerts by level — {days} days' },
  'chart.actionBreakdown': { fr: 'Répartition par action', en: 'Breakdown by action' },
  // Le français sépare le signe de pourcentage par une espace, l'anglais le colle.
  'chart.percent': { fr: '{v} %', en: '{v}%' },
} satisfies Bundle
